import Quill from 'quill';
import RestUtilities from 'lib/RestUtilities';
import { AsyncUploadModel } from 'models/ApiModels';
import { QuillUtils } from 'components/Quill/QuillUtils';

class ImageDropAndPaste {
    private quill: any;
    private options: any;
    private uploadToServer = true;

    constructor(quill: any, options = {}) {
        this.quill = quill
        this.options = options
        this.handleDrop = this.handleDrop.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.quill.root.addEventListener('drop', this.handleDrop, false)
        this.quill.root.addEventListener('paste', this.handlePaste, false)
    }

	/* handle image drop event
	*/
    handleDrop(e: any) {
        e.preventDefault()
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
            if (document.caretRangeFromPoint) {
                const selection = document.getSelection()
                const range = document.caretRangeFromPoint(e.clientX, e.clientY)
                if (selection && range) {
                    selection.setBaseAndExtent(range.startContainer, range.startOffset, range.startContainer, range.startOffset)
                }
            }
            this.readFiles(e.dataTransfer.files, (dataUrl: any, type: any) => {
                if (typeof this.options.handler === 'function') {
                    this.options.handler(dataUrl, type)
                } else {
                    this.insert.call(this, dataUrl, type)
                }
            })
        }
    }

	/* handle image paste event
	*/
    handlePaste(e: any) {

        if (e.clipboardData && e.clipboardData.items && e.clipboardData.items.length) {
            const files = e.clipboardData.items as DataTransferItemList;

            let countFiles = 0;
            for (let i = 0; i < files.length; i++) {
                if (files[i].kind == "file") countFiles++;
            }

            if (countFiles > 0) {
                e.preventDefault();

                this.readFiles(files, (dataUrl: any, type: any) => {
                    setTimeout(() => {
                        if (typeof this.options.handler === 'function') {
                            this.options.handler(dataUrl, type)
                        } else {
                            this.insert(dataUrl, type)
                        }
                    }, 0)
                });
            }
        }
    }

	/* read the files
	*/
    readFiles(files: any, callback: any) {
        [].forEach.call(files, (file: any) => {
            var type = file.type
            if (!file.type.match(/^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i)) return

            if (this.uploadToServer) {

                const utils = new QuillUtils();

                var cover = utils.createBackDrop();
                var container = document.querySelector(".ql-container");
                container.appendChild(cover);

                const blob = file.getAsFile ? file.getAsFile() : file

                const formData = new FormData();
                formData.append('file', blob);

                RestUtilities.post<AsyncUploadModel>('/api/v1.0/AsyncUpload/Save', formData)
                    .then((response) => {
                        container.removeChild(cover);
                        callback(response.mainFile.attachUrl, type)
                    })
                    .catch((error) => {
                        console.log('quill image upload failed');
                        console.warn(error);
                        container.removeChild(cover);
                    });
            }
            else {
                const reader = new FileReader()
                reader.onload = (e: any) => {
                    callback(e.target.result, type)
                }
                const blob = file.getAsFile ? file.getAsFile() : file
                if (blob instanceof Blob) reader.readAsDataURL(blob)
            }
        })
    }

    imageHandler(file: any) {
    }


	/* insert into the editor
	*/
    insert(dataUrl: any, type: any) {
        const index = (this.quill.getSelection() || {}).index || this.quill.getLength()
        this.quill.insertEmbed(index, 'image', dataUrl, 'user')
        this.quill.setSelection(index + 2, 1, "user");
    }
}

Quill.register('modules/imageDropAndPaste', ImageDropAndPaste);